import { List, ListSubheader, ListItem, ListItemText } from '@mui/material';
import { SnapshotSpectralMask } from 'types';

interface Props {
  masks: SnapshotSpectralMask[] | undefined;
  selectedMaskId: number;
  handleMaskClicked: (maskId: number) => void;
}

const SpectralMaskList = ({
  masks,
  selectedMaskId,
  handleMaskClicked,
}: Props) => {
  return (
    <List>
      <ListSubheader>Spectral Masks</ListSubheader>
      {masks?.map((mask) => (
        <ListItem
          key={mask.id}
          button
          selected={mask.id === selectedMaskId}
          onClick={() => handleMaskClicked(mask.id)}
        >
          <ListItemText key={mask.id}>{mask.name}</ListItemText>
        </ListItem>
      ))}
    </List>
  );
};

export default SpectralMaskList;
